import _ from 'underscore';

const StrengthIcon = {
  Poor: 'Error',
  Average: 'Warning',
  Good: 'Completed',
  Excellent: 'Completed',
};

export function getStrengthIcon(strength) {
  return StrengthIcon[strength] || 'Error';
}

export function getActionItems({ i18n, actionItems }) {
  const actionItemsList = [];
  _.each(actionItems, (item) => {
    actionItemsList.push(i18n.getString(`Ad_Strength_Suggestion_${item}`));
  });
  return actionItemsList;
}
